import { render, staticRenderFns } from "./AddEditRequests.vue?vue&type=template&id=cbc6e48a"
import script from "./AddEditRequests.vue?vue&type=script&lang=js"
export * from "./AddEditRequests.vue?vue&type=script&lang=js"
import style0 from "./AddEditRequests.vue?vue&type=style&index=0&id=cbc6e48a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports